import { emptyObj } from 'util/objects'

export const foldersByIdSelector = state => state.folders.byId || emptyObj
